module.exports = __webpack_public_path__ + "static/media/cool-background.d806899b.png";